import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
  Col,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import { UnBillsType } from "_mock/Static_data"
import WhatsAppMessageTable from "./WhatsAppMessageTable"
import { exportDataExcel } from "components/Common/ExportData"

function WhatsAppMessages() {
  document.title = `WhatsApp Message | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [filterCategoryId, setFilterCategoryId] = useState(0)
  const [whatsAppMessageId, setWhatsAppMessageId] = useState(0)
  const [categoryId, setCategoryId] = useState(0)
  const [categories, setCategories] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    getApi("Common/category/lookup").then(({ data, status }) => {
      if (status === 200) {
        setCategories(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])


  // WhatsApp Message list api
  const whatsAppMessageApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    getApi(`Common/whatsapp-msg/list?categoryId=${filterCategoryId}`).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setScreenLoad(false)
    })
  }

  // WhatsApp Message list api useEffect
  useEffect(() => {
    whatsAppMessageApi()
  }, [filterCategoryId])

  // toggle handlers
  const toggle = () => {

    setModal(!modal)
    validation.handleReset()
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete WhatsApp Message handler
  const handleDelete = (whatsAppMessageId) => {
    setScreenLoad(true)
    if (whatsAppMessageId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this message permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/whatsapp-msg/delete?Id=${whatsAppMessageId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== whatsAppMessageId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Message",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update WhatsApp Message handler
  const handleEditWhatsAppMessage = (whatsAppMessagedata) => {
    if (whatsAppMessagedata) {
      setWhatsAppMessageId(whatsAppMessagedata.Id)
      setCategoryId(whatsAppMessagedata?.CategoryId)
      setIsEdit(true)
      setModal(!modal)
      setEditData(whatsAppMessagedata)
    }
  }

  // Create WhatsApp Message handler
  const handleWhatsAppMessageClick = () => {
    setIsEdit(false)
    setCategoryId(0)
    toggle()
  }

  // WhatsApp Message Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Message: isEdit ? editData?.Message : "",
      Days: isEdit ? editData?.Days : "",
    },
    validationSchema: Yup.object({
      Message: Yup.string().required("The message is required"),
      Days: Yup.string().required("The days is required"),
    }),
    onSubmit: values => {

      if (parseInt(categoryId) == 0) {
        setIsError(true)
        setErrorMessage("The category is required")
        return true
      }

      setformSumitLoading(true)
      if (values) {
        postApi("Common/whatsapp-msg/addedit", {
          Id: isEdit ? parseInt(whatsAppMessageId) : 0,
          CategoryId: parseInt(categoryId),
          Message: values.Message,
          Days: parseInt(values.Days),
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            whatsAppMessageApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  // WhatsApp Message table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Message",
        accessor: "Message",
        Cell: ({ row }) => {
          return (
            <>
              <div className="text-wrap" style={{ display: "flex", text: "wrap" }}>{row.original.Message}</div>
            </>
          )
        }
      },
      {
        Header: "Category",
        accessor: "CategoryName",
        width: "8%",
      },
      {
        Header: "Days",
        accessor: "Days",
        width: "4%",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{ display: "flex", justifyContent: "center" }}>{row.original.Days}</div>
            </>
          )
        }
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditWhatsAppMessage(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Message", "Category Name"];
    const mainTitle = "WhatsApp Messages";
    const widthObj = [{
      Key: "A",
      Value: 100,
    },
    {
      Key: "B",
      Value: 25,
    },
    ]
    const extention = "WhatsApp_Msg.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData.length; index++) {
      let dataObj = {
        Message: tableData[index].Message,
        CategoryName: tableData[index].CategoryName,
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <WhatsAppMessageTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              handleWhatsAppMessageClick={handleWhatsAppMessageClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              categories={categories}
              filterCategoryId={filterCategoryId}
              setFilterCategoryId={setFilterCategoryId}
              writeDataToExcel={writeDataToExcel}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "500px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Message" : "Create Message"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        Message
                      </Label>
                      <Input
                        name="Message"
                        placeholder="Message"
                        type="textarea"
                        rows="4"
                        className="form-control-sm"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Message || ""}
                        invalid={
                          validation.touched.Message && validation.errors.Message
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Message && validation.errors.Message ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Message}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                    <Row>
                      <Col md={8}>
                        <FormGroup className="mb-2">
                          <Label
                            htmlFor="validationCustom03"
                            className="required"
                          >
                            Category
                          </Label>
                          <Input
                            type="select"
                            bsSize="sm"
                            id="validationCustom01"
                            className="form-control-sm"
                            name="category"
                            onChange={e => {
                              setCategoryId(e.target.value)
                              setIsError(false)
                            }}
                            onBlur={validation.handleBlur}
                            value={categoryId}
                          >
                            <option value={0}>Select Category</option>
                            {categories.map((item, index) => {
                              return (
                                <option key={index} value={item.Key}>{item.Value}</option>
                              )
                            })}
                          </Input>
                          {isError ? (
                            <div className="name-required">
                              {errorMessage}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Days
                          </Label>
                          <Input
                            name="Days"
                            placeholder="0"
                            type="text"
                            onKeyPress={handleKeyPress}
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Days || ""}
                            invalid={
                              validation.touched.Days && validation.errors.Days
                                ? true
                                : false
                            }
                          />
                          {validation.touched.Days && validation.errors.Days ? (
                            <FormFeedback type="invalid">
                              {validation.errors.Days}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
WhatsAppMessages.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default WhatsAppMessages